const Product = {

    // FIELDS
    "product_code": "Product Code",
    "category": "Category",
    "name": "Name",
    "description": "Description",
    "type": "Type",
    "status": "Status",
    "reorder_level": "Re-order Level",
    "hero_product": "Hero Product",
    "hero_image": "Hero Image",
    "hero_true": "True",
    "hero_false": "False",
    "search": "Search",
    "image": "Image",
    "priority": "Priority",
    "product_variants": "Variants",
    "variant_value": "Value",
    "unit": "Unit",
    "price": "Price",
    "discount": "Discount (%)",
    "gst": "GST (%)",
    "final_price": "Final Price",
    "nutrition_parameters": "Nutrition Parameters",
    "title": "Title",
    "value": "Value",
    "percentage": "Percentage (%)",
    "ingredient_parameters": "Ingredients",
    "ingredient": "Title",
    "ingredient_description": "Description",

    // TYPES
    "type_bestseller": "Bestseller",
    "type_new_arrival": "New Arrival",
    "type_featured": "Featured",
    "type_trending": "Trending",
    "type_recommended": "Recommended",

    // PAGE HEADER
    "product": "Product",
    "basic_info": "Basic Info",
    "variants_info": "Product Variants",
    "images_info": "Product Images",
    "hero_image_info": "Hero Image",
    "nutrition_info": "Nutrition Parameters",
    "nutrition_empty": "No nutrition parameters available",
    "ingredient_info": "Ingredients",
    "ingredient_empty": "No ingredients available",
    "variants_empty": "No product variants available",
    "images_empty": "No product images available",
    "hero_image_empty": "No hero image available",
    "details_error": "Something went wrong, can't load product details",
    "reviews": "Reviews",
    "reviews_title": "Product Reviews",
    "reviews_error": "Something went wrong, can't load product reviews",
    "reviews_empty": "No reviews available for this product",
    "rating_breakdown": "Rating Breakdown",
    "star_label": "Star",
    "stars_label": "Stars",
    "based_on": "Based on",
    "review_count_one": "review",
    "review_count_many": "reviews",

    // ERROR
    "error_category": "Select Category",
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_type": "Select Type",
    "error_status": "Select Status",
    "error_reorder_level": "Enter Re-order Level",
    "error_hero_product": "Select Hero Product",
    "error_variant": "Add at least one variant",
    "error_variant_value": "Enter Variant Value",
    "error_unit": "Select Unit",
    "error_image": "Upload Image",
    "error_hero_image": "Upload Hero Image",
    "error_priority": "Enter Priority",
    "error_percentage": "Percentage must be between 0 and 100",
    "error_title": "Enter Title",
    "error_value": "Enter Value",
    "error_file_size": "Image size must be less than 5MB",
    "error_file_type": "Only JPG, JPEG, PNG images are allowed",

    // TABLE HEADER
    "table_product_code": "PRODUCT CODE",
    "table_name": "NAME",
    "table_category": "CATEGORY",
    "table_type": "TYPE",
    "table_status": "STATUS",
    "table_hero_product": "HERO PRODUCT",

}

export default Product;